import React, { useRef, useState } from "react";
import WebSkyLayout from "./WebSkyLayout";
import { useParams } from "react-router-dom";
import { useMatchDetailLogic } from "../../useLogic/useMatchDetailLogic";
import BookmakerSkyWeb from "./Bookmaker";
import FancySkyWeb from "./Fancy";
import SportbookWebSky from "./SportBook";
import { formatWithCommas } from "../../../Utils/Toast";
import BetFair from "./BetFair";
import LiveMatchTrackerCricket from "../../Score/Cricket/ScoerBoardDetail";
import { isEmpty } from "lodash";
import ReactPlayer from "react-player";
import LoadingImage from "../../../assets/images/cover-live.webp";
import { IoVolumeHighSharp, IoVolumeMuteSharp } from "react-icons/io5";
const DetailWebSky = () => {
  const parmas = useParams();
  const ref = useRef(null);
  const [showTv, setShowTv] = useState(false);
  const {
    // context
    user,
    profileData,
    showBetDialog,
    betSlipObject,
    setBetSlipObject,

    // state
    fancyModal,
    setFancyModal,
    loading,
    setLoading,
    mute,
    setMute,
    setTvClass,
    fancyTab,
    setFancyTab,
    marketNew,
    marketName,
    setMarketName,
    marketId,
    setMarketId,
    detail,
    bookmakerOdds,
    sportsBookPosition,
    bookmaker,
    fancy,
    sportsBook,
    fancyPosition,
    runner,
    setRunner,
    fancyHeader,
    favouriteList,

    // functions
    getBetPosition,
    getMatchOdds,
    addToFavioute,

    // memoized
    totalMatched,
    backOdds,
    layOdds,
    backOddsBookmaker,
    layOddsBookmaker,
    oldBack,
    oldLay,
    oldBackBookmaker,
    oldLayBookmaker,
    ms,
    positionMemo,
    positionMemoBookmaker,
    profileDataMemo,
    showFancy,
    showSportbook,

    tv,
    getMatchDetails,
  } = useMatchDetailLogic();
  const displayScore = () => {
    return detail?.eventId && detail?.eventId.toString().startsWith("-1") ? (
      // <LiveMatchTrackerCricket type="inner" scoreId={detail?.scoreId} />
      <iframe
        className="w-full aspect-video relative"
        style={{
          overflow: "hidden",
          height: detail?.screenScore === "full" ? "270px" : "141px",
          backgroundColor: "#000000",
          width:`100%`
        }}
        id="scoreId"
        src={detail?.scoreURL}
      ></iframe>
    ) : (
       <iframe
        className="w-full aspect-video relative"
        style={{
          overflow: "hidden",
          height: detail?.screenScore === "full" ? "270px" : "141px",
          backgroundColor: "#000000",
          width:`100%`
        }}
        id="scoreId"
        src={detail?.scoreURL}
      ></iframe>
    );
  };
  return (
    <WebSkyLayout
      eventName={detail?.eventName}
      gameType={detail?.gameType}
      seriesName={detail?.seriesName}
    >
      {" "}
      <div id="centerColumn" className="col-center markets">
        <div id="overWrap" className="over-wrap live-match">
          <div id="liveMatchGameHead" className="game-head">
            <div id="matchTrackerWrap" className="match-tracker-wrap">
              {!["horse", "greyhound"].includes(parmas?.type) &&
                !isEmpty(detail?.scoreId) &&
                detail?.scoreId != "false" &&
                displayScore()}
              <ul id="liveMatchTrackerBtn" className="match-btn">
                <li>
                  <a
                    id="liveMultiMarketPin"
                    style={{ cursor: "pointer" }}
                    name="gameHeadPin"
                    className="btn-pin"
                  />
                </li>
                <li>
                  <a style={{ cursor: "pointer" }} className="btn-refresh" />
                </li>
              </ul>
            </div>
            <div id="scoresEvent" className="match-odds">
              Match Odds
              <img src="/assets/images/transparent.gif" />
            </div>

            {detail?.status == "in_play" && (
              <ul className="game-info" style={{ display: "block" }}>
                <li id="gameInfoDate" className="green">
                  <img
                    className="icon-irun"
                    src="/assets/images/transparent.gif"
                  />{" "}
                  In-Play
                </li>
              </ul>
            )}
            {/* <span id="lowLiquidityTag" className="game-low_liq" style={{}}>
              Low Liquidity
            </span> */}
            {detail?.status == "in_play" && (
              <a
                onClick={() => setShowTv(!showTv)}
                id="lmtOpenStreaming"
                className={`open-tv-wrap ${showTv ? "close_tv" : ""} `}
                style={{ display: "flex" }}
              >
                Live
              </a>
            )}
            <dl className="game-matched" style={{ display: "block" }}>
              <dt>Matched</dt>
              <dd id="liveGameMatched">
                BDT{" "}
                {formatWithCommas(
                  marketNew?.length > 0 ? marketNew[0]?.odds?.totalMatched : 0
                )}
              </dd>
            </dl>
            {/* <dl id="minMaxBox" className="fancy-info" style={{}}>
              <dt id="minMaxDt" style={{}}>
                Min/Max
              </dt>
              <dt id="maxDt" style={{ display: "none" }}>
                Max
              </dt>
              <dd id="minMaxInfo">100 / 8750</dd>
            </dl> */}
          </div>
          {showTv && !isEmpty(user) && detail?.status == "in_play" && (
            <div
              id="tv-wrap"
              className="game-streaming-wrap"
              style={{ display: "block", position: "relative" }}
            >
              {loading && (
                <img
                  src={LoadingImage}
                  alt="Thumbnail"
                  className="w-full aspect-video relative"
                  style={{
                    padding: "0",
                    position: "absolute",
                    margin: "0",
                    left: "25%",
                    width: "inherit",
                    height: "inherit",
                  }}
                />
              )}
              {!loading && (
                <>
                  {mute ? (
                    <IoVolumeMuteSharp
                      onClick={() => setMute(!mute)}
                      style={{
                        position: "absolute",
                        right: "33%",
                        zIndex: "99999",
                        bottom: "6%",
                      }}
                      size={20}
                      color="white"
                    />
                  ) : (
                    <IoVolumeHighSharp
                      onClick={() => setMute(!mute)}
                      style={{
                        position: "absolute",
                        right: "33%",
                        zIndex: "99999",
                        bottom: "6%",
                      }}
                      size={20}
                      color="white"
                    />
                  )}{" "}
                </>
              )}
              <ReactPlayer
                muted={mute}
                controls={false}
                ref={ref}
                playsinline={true}
                loop={true}
                playing={true}
                id="videoFrame"
                className="s-w-full s-aspect-video s-relative s-z-0"
                onReady={() => setLoading(false)} // Video is ready → hide loader
                onBuffer={() => setLoading(true)} // When buffering → show loader
                onBufferEnd={() => setLoading(false)} // Buffer ends → hide loader
                width={375}
                height="100%"
                url={`https://cceucceu.cc/${detail.channel}/index.m3u8`}
                config={{
                  youtube: {
                    playerVars: {
                      showinfo: 1,
                      fs: 1,
                      controls: 1,
                    },
                  },

                  file: {
                    attributes: {
                      preload: "none",
                      crossOrigin: "true",
                    },
                    hlsOptions: {
                      startLevel: 3,
                    },
                  },
                }}
              />
            </div>
          )}
          {marketNew?.map((res) => {
            return (
              res?.jsonData?.length > 0 && (
                <BetFair
                  object={res}
                  runner={res?.jsonData}
                  backOdds={res?.odds?.back_odds}
                  layOdds={res?.odds?.lay_odds}
                  oldBack={res?.odds?.back_odds_old}
                  oldLay={res?.odds?.lay_odds_old}
                  ms={res?.odds?.ms}
                  name={res?.market}
                  marketId={res?.marketId}
                  totalMatched={res?.odds?.totalMatched}
                  detail={detail}
                  user={user}
                  profileData={profileDataMemo}
                  typeGame="betFaire"
                  marketName={res?.market}
                  position={positionMemo}
                />
              )
            );
          })}

          {detail?.bookMaker == "on" &&
            detail?.gameType == "cricket" &&
            bookmaker?.length > 0 && (
              <BookmakerSkyWeb
                runner={bookmaker}
                marketId={parmas?.marketId}
                detail={detail}
                backOdds={backOddsBookmaker}
                layOdds={layOddsBookmaker}
                oldBack={oldBackBookmaker}
                oldLay={oldLayBookmaker}
                ms={detail?.bookMaker == "on" ? bookmakerOdds?.ms : 3}
                position={positionMemoBookmaker}
                profileData={profileDataMemo}
                addToFavioute={addToFavioute}
                typeGame="bookmaker"
                marketName={"Bookmaker"}
                user={user}
              />
            )}
          {fancyTab == "Fancy" &&
            parmas?.type != "multi" &&
            !["Winner", "Win"].includes(detail?.market) &&
            detail?.gameType == "cricket" &&
            detail?.hasFancy && (
              <FancySkyWeb
                fancy={fancy}
                detail={detail}
                fancyHeader={fancyHeader}
                position={fancyPosition}
                typeGame={"fancy"}
                setFancyTab={setFancyTab}
                profileData={
                  detail?.matchSetting?.length > 0
                    ? {
                        ...detail,
                        arrayCheck: "details",
                        profile: profileData,
                      }
                    : {
                        ...profileData,
                        arrayCheck: "profile",
                        profile: profileData,
                      }
                }
                setFancyModal={setFancyModal}
              />
            )}
          {(parmas?.type == "multi" ? true : fancyTab == "Premium") &&
            (detail?.premiumFancy == "on" || detail?.hasSportBook) && (
              <SportbookWebSky
                data={sportsBook}
                user={user}
                favouriteList={favouriteList}
                detail={detail}
                setFancyTab={setFancyTab}
                position={sportsBookPosition}
                setBetSlipObject={setBetSlipObject}
                betSlipObject={betSlipObject}
                profileData={
                  detail?.matchSetting?.length > 0
                    ? {
                        ...detail,
                        arrayCheck: "details",
                      }
                    : {
                        ...profileData,
                        arrayCheck: "profile",
                      }
                }
                addToFavioute={addToFavioute}
              />
            )}
        </div>
      </div>
    </WebSkyLayout>
  );
};

export default DetailWebSky;
